export const myTemplate = (h, props) => {
  const isExit = typeof props.model[props.prop] !== 'undefined' ? props.model[props.prop] : null
  if (isExit !== null) {
    const icon = isExit ? require('@/assets/log-out-outline.svg') : require('@/assets/log-in-outline.svg')
    return h('div', { class: { 'icon-container': true } },
      [
        h('img', {
          class: { 'filter-green': !isExit, 'filter-red': isExit, 'exit-icon': true },
          src: icon,
        }),
        h('span', {}, [!isExit ? 'in' : 'out'])
      ])
  }
  return <span></span>
}
